export function isValidEmailAddress(input) {
  const inputString = String(input);
  const regex = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
  if (!inputString) return false;
  return regex.test(inputString);
}
